/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BannerListItemDto } from '../models/BannerListItemDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BannersService {
  /**
   * 배너 목록 조회
   * @returns BannerListItemDto
   * @throws ApiError
   */
  public static bannerControllerFindAllBanners(): CancelablePromise<
    Array<BannerListItemDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/banners',
    });
  }
}
